import React from 'react';
import { object } from 'prop-types';

import moment from 'moment';
import s from './AppointmentBodyContainer.css';

const prettyPrintTime = (minutesSinceMidnight) => {
  const hour = Math.floor(minutesSinceMidnight / 60);
  const minute = minutesSinceMidnight % 60;
  const hourStr = hour < 10 ? '0' + hour.toString() : hour.toString();
  const minuteStr = minute < 10 ? '0' + minute.toString() : minute.toString();
  return moment(hourStr + minuteStr, 'Hm').format('h:mmA');
};

const prettyPrintAddress = (location) =>
  (location.address1 ? location.address1 + ' ' : '') +
  (location.address2 ? location.address2 + ' ' : '') +
  (location.city ? location.city + ', ' : '') +
  (location.state ? location.state + ' ' : '') +
  (location.postalCode ? location.postalCode : '');

const AppointmentBodyContainer = ({ appt }) => {
  const time = prettyPrintTime(appt.time);
  const address = prettyPrintAddress(appt.location);

  return (
    <section className={s.component}>
      <h4 className={s.primary}>{time + ' ' + appt.type}</h4>
      <h4 className={s.secondary}>{appt.with}</h4>
      <h4 className={s.tertiary}>{address}</h4>
      <h4 className={s.tertiary}>{appt.location.name}</h4>
    </section>
  );
};

AppointmentBodyContainer.propTypes = {
  appt: object,
};

export default AppointmentBodyContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentBody/AppointmentBodyContainer.js